  <div class="player-root">
    <div class="player-partLeft">
        <span *ngIf="!isPlaying" class="fa fa-play" aria-hidden="true" (click)="playTrack()" style="cursor: pointer; display:inline-block;margin-right:10px;" title="Play"></span>
        <span *ngIf="isPlaying" class="fa fa-pause" aria-hidden="true" (click)="pauseTrack()" style="cursor: pointer; display:inline-block;" title="Pause"></span>
    </div>
    <div class="player-partMain">
        <input *ngIf="isPlaying" type="range" value="{{value}}" min="0" max="{{duration}}" step="any" class="music-slider" (input)="seekTime($event)" />
    </div>
  </div>